/** @format */
import { Component, Input, OnInit } from '@angular/core';

import { AnalyticsService } from '@shared/utils/services';
import { PersonalInformation } from '@shared/data-access/interfaces';
import { Store } from '@shared/data-access/services';

@Component({
	selector: 'scorecard-scorecard-gold',
	templateUrl: './scorecard-gold.component.html',
	styleUrl: './scorecard-gold.component.scss',
	standalone: false
})
export class ScorecardGoldComponent implements OnInit {
	constructor(
		private analyticsService: AnalyticsService,
		private store: Store
	) {}

	personalInformation: any;

	finishedAnimating = false;
	showFireworks = false;

	@Input() abbreviatedVersion = false;

	ngOnInit() {
		this.store.select<PersonalInformation>('PERSONAL_INFO', true).subscribe((personalInfo) => {
			this.personalInformation = personalInfo;
		});
	}

	get cappedCurrentYearSales() {
		const currentYearSales = this.personalInformation?.currentYearSales;
		return currentYearSales > 500 ? 500 : currentYearSales;
	}

	get unlockedStatus() {
		if (this.personalInformation?.isGold) {
			return `YOU'VE GOT THE GOLD!\n\nScoreCard Gold Unlocked!`;
		} else {
			return 'Progress to ScoreCard Gold';
		}
	}

	get deadline() {
		let year = new Date(Date.now()).getFullYear();
		year = new Date(this.personalInformation?.tierExpiration).getFullYear();

		return `Your ScoreCard Gold status will last through Dec ${year}.`;
	}

	get goldExtendDate() {
		const year = new Date(Date.now()).getFullYear() + 1;
		return `Spend $500 by the end of the year to extend your gold status through Dec. ${year}!`;
	}

	get goldSpendDate() {
		const year = new Date(Date.now()).getFullYear();
		return `Spend $500 by the end of Dec 31st, ${year} to unlock ScoreCard Gold and earn exclusive benefits and rewards!`;
	}

	public onExpand() {
		this.analyticsService.setEventType('ScoreCardGoldLearnMoreExpand');
		this.analyticsService.triggerAnalyticsEvent('ScoreCardGoldLearnMoreExpand');
	}

	public onCollapse() {
		this.analyticsService.setEventType('ScoreCardGoldLearnMoreCollapse');
		this.analyticsService.triggerAnalyticsEvent('ScoreCardGoldLearnMoreCollapse');
	}

	public accordionClicked(isCollapsed: boolean) {
		if (isCollapsed) {
			this.onCollapse();
		} else {
			this.onExpand();
		}
	}

	public balanceProgress(): number {
		const currentYearSales = this.personalInformation?.currentYearSales;

		if (!currentYearSales) {
			return 0;
		}

		if (currentYearSales >= 500) {
			return 100;
		}

		return (100 * currentYearSales) / 500;
	}

	balanceProgressCss(): string {
		const progress = this.balanceProgress();
		let adjustment = '0px';

		if (progress <= 10) {
			adjustment = '10px';
		}

		if (progress > 10 && progress < 100) {
			adjustment = '-8px';
		}
		return `calc(${progress}% + ${adjustment})`;
	}

	roundedSalesBalance(): number {
		if (!this.cappedCurrentYearSales) {
			return 0;
		}

		return Math.floor(this.cappedCurrentYearSales);
	}

	finishGoldBarAnimation(event) {
		if (!event.value) {
			return;
		}
		this.finishedAnimating = true;
	}

	toggleFireworks() {
		this.analyticsService.setEventType('ConfettiClick');
		this.analyticsService.triggerAnalyticsEvent('ConfettiClick');

		this.showFireworks = !this.showFireworks;

		// Turn off after 2 seconds
		if (this.showFireworks) {
			setTimeout(() => {
				this.toggleFireworks();
			}, 2000);
		}
	}

	goldExpiresThisYear(expDate: Date): boolean {
		const currDate = new Date(Date.now());
		const expirationDate = new Date(expDate);

		const diffTime = expirationDate.getTime() - currDate.getTime();
		const diffDays = diffTime / (1000 * 3600 * 24);

		if (diffDays <= 365) {
			return true;
		}

		return false;
	}
}
